import Breadcrumbs from 'Components/Breadcrumbs'
import SchoolCalendarForm from 'Services/SchoolManagement/Features/SchoolCalendar/Components/SchoolCalendarForm'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/system'
import { t } from 'ttag'

function SchoolCalendarCreatePage() {
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/school-management/school-calendars/`
  const previousLocation = usePreviousLocation(baseUrl)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: '/school-management/'
    },
    {
      title: t`Calendars`,
      link: baseUrl
    },
    {
      title: t`Create new calendar`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
        </Grid>
      </Grid>
      <SchoolCalendarForm successBaseUrl={previousLocation} />
    </Box>
  )
}

export default SchoolCalendarCreatePage
